import React from 'react';
import { Form, Select, Input, Space } from 'antd';

export const COUNTRY_OPTIONS = [
  { value: 'US', label: '美国 US' },
  { value: 'CN', label: '中国大陆 CN' },
  { value: 'HK', label: '中国香港 HK' },
  { value: 'GB', label: '英国 GB' },
  { value: 'DE', label: '德国 DE' },
  { value: 'FR', label: '法国 FR' },
  { value: 'JP', label: '日本 JP' },
  { value: 'KR', label: '韩国 KR' },
  { value: 'AU', label: '澳大利亚 AU' },
  { value: 'CA', label: '加拿大 CA' },
];

interface AddressFieldsProps {
  /** 对应 Form 里嵌套字段的前缀，如 ['origin'] / ['destination'] */
  namePath: string[];
  /** minimal：只要求国家+邮编（报价阶段）；full：标准完整地址（购买运单阶段） */
  mode: 'minimal' | 'full';
}

/**
 * 报价和购买运单共用的地址表单片段。
 * minimal 模式只有国家+邮编两个必填框；full 模式是购买运单需要的标准地址字段。
 */
const AddressFields: React.FC<AddressFieldsProps> = ({ namePath, mode }) => {
  const full = mode === 'full';

  return (
    <>
      <Space size="large" wrap align="start">
        <Form.Item
          label="国家/地区"
          name={[...namePath, 'country']}
          rules={[{ required: true, message: '请选择国家/地区' }]}
          style={{ width: 180 }}
        >
          <Select options={COUNTRY_OPTIONS} />
        </Form.Item>
        <Form.Item
          label="邮编"
          name={[...namePath, 'postal_code']}
          rules={[{ required: true, message: '请输入邮编' }]}
          style={{ width: 140 }}
        >
          <Input />
        </Form.Item>
        {full && (
          <>
            <Form.Item label="州/省" name={[...namePath, 'state']} rules={[{ required: true, message: '请输入州/省' }]}>
              <Input style={{ width: 140 }} />
            </Form.Item>
            <Form.Item label="城市" name={[...namePath, 'city']} rules={[{ required: true, message: '请输入城市' }]}>
              <Input style={{ width: 160 }} />
            </Form.Item>
          </>
        )}
      </Space>

      {full && (
        <>
          <Space size="large" wrap align="start">
            <Form.Item label="收件人姓名" name={[...namePath, 'name']} rules={[{ required: true, message: '请输入姓名' }]}>
              <Input style={{ width: 180 }} />
            </Form.Item>
            <Form.Item label="公司名称" name={[...namePath, 'company']}>
              <Input style={{ width: 180 }} />
            </Form.Item>
            <Form.Item label="电话" name={[...namePath, 'phone']} rules={[{ required: true, message: '请输入电话' }]}>
              <Input style={{ width: 160 }} />
            </Form.Item>
            <Form.Item label="Email" name={[...namePath, 'email']}>
              <Input style={{ width: 220 }} />
            </Form.Item>
          </Space>
          <Space size="large" wrap align="start">
            <Form.Item label="地址第一行" name={[...namePath, 'address_line']} rules={[{ required: true, message: '请输入详细地址' }]}>
              <Input style={{ width: 260 }} />
            </Form.Item>
            <Form.Item label="地址第二行" name={[...namePath, 'address_line2']}>
              <Input style={{ width: 260 }} />
            </Form.Item>
          </Space>
        </>
      )}
    </>
  );
};

export default AddressFields;
